import { ReactNode } from 'react'
import { IconElement } from 'types/ui'

import { Button } from '@elements/button'
import { Link } from '@elements/link'
import { H3 } from '@elements/headings'

export function VenueContactCard({
  children,
  heading,
  href,
  ctaLabel,
  ctaIcon,
}: {
  children: ReactNode
  href: string
  heading: string
  ctaLabel: string
  ctaIcon?: IconElement
}) {
  return (
    <div className="flex flex-col w-full md:max-w-[380px] h-auto space-y-2 md:space-y-3">
      <H3 className="heading-lg">{heading}</H3>
      <div className="flex flex-col items-center justify-between h-full p-4 space-y-4 border rounded grow border-standard-light bg-card dark:bg-dark-background min-h-[8rem]">
        <div className="flex flex-col items-center justify-center h-full">{children}</div>
        <div className="w-full">
          <Link href={href} className="w-full" target="_blank" rel="noreferrer">
            <Button.Floating className="w-full" rightIcon={ctaIcon}>
              {ctaLabel}
            </Button.Floating>
          </Link>
        </div>
      </div>
    </div>
  )
}
